/**
 * 공통 API 서비스 (학교, 학과 등)
 */

import apiClient from '../../core/http/axios';

export interface University {
  university_no: number;
  name: string;
}

export interface Department {
  department_no: number;
  name: string;
  university_no: number;
}

export interface UniversityListResponse {
  success: boolean;
  error: string | null;
  data: University[];
  code: string | null;
  meta: {
    elapsed_ms: number;
  };
}

export interface DepartmentListResponse {
  success: boolean;
  error: string | null;
  data: Department[];
  code: string | null;
  meta: {
    elapsed_ms: number;
  };
}

/**
 * 학교 목록 조회
 */
export const getUniversities = async (): Promise<University[]> => {
  const response = await apiClient.get<UniversityListResponse>('/common/university');
  return response.data.data;
};

/**
 * 학과 목록 조회
 */
export const getDepartments = async (universityNo: number): Promise<Department[]> => {
  const response = await apiClient.get<DepartmentListResponse>(
    `/common/university/${universityNo}/department`
  );
  return response.data.data;
};
